import dayjs from 'dayjs';

function convertHexToHSL(hexColor) {
  hexColor = hexColor.replace(/^#/, '');
  if (hexColor.length === 3) {
    hexColor = hexColor
      .split('')
      .map((char) => char + char)
      .join('');
  }
  const redComponent = parseInt(hexColor.substring(0, 2), 16) / 255;
  const greenComponent = parseInt(hexColor.substring(2, 4), 16) / 255;
  const blueComponent = parseInt(hexColor.substring(4, 6), 16) / 255;
  const maxColorValue = Math.max(redComponent, greenComponent, blueComponent);
  const minColorValue = Math.min(redComponent, greenComponent, blueComponent);
  let hue = 0, saturation = 0, lightness = 0;
  lightness = (maxColorValue + minColorValue) / 2;
  if (maxColorValue === minColorValue) {
    hue = 0;
    saturation = 0;
  } else {
    const colorDifference = maxColorValue - minColorValue;
    saturation
    = lightness > 0.5
        ? colorDifference / (2 - maxColorValue - minColorValue)
        : colorDifference / (maxColorValue + minColorValue);
    switch (maxColorValue) {
    case redComponent:
      hue
      = (greenComponent - blueComponent) / colorDifference
      + (greenComponent < blueComponent ? 6 : 0);
      break;
    case greenComponent:
      hue = (blueComponent - redComponent) / colorDifference + 2;
      break;
    case blueComponent:
      hue = (redComponent - greenComponent) / colorDifference + 4;
      break;
    default:
      hue = 0;
    }
    hue *= 60;
  }
  return { hue, saturation, lightness };
}

function getLighterBackgroundColor(hexColor, lightnessIncrease = 60) {
  const { hue, saturation, lightness } = convertHexToHSL(hexColor);
  const newLightness = Math.min(lightness * 100 + lightnessIncrease, 95);
  return `hsl(${hue}, ${saturation * 100}%, ${newLightness}%)`;
}

export const customStatusStyles = (statusColor) => {
  return {
    backgroundColor: statusColor === '#7A757F' ? '#ECEDF4' : getLighterBackgroundColor(statusColor),
    color: `${statusColor} !important`,
    width: 'auto !important',
    '.MuiOutlinedInput-input': { color: `${statusColor} !important` },
    '& .MuiSelect-icon': { color: `${statusColor} !important` },
    '&:hover': { border: 'none !important' },
    '& .MuiOutlinedInput-notchedOutline': {border: 'none !important'},
    '& .MuiSelect-select': { padding: '2px 0 2px 10px'},
  };
};

export const formatDate = (dateStr) => {
  return dateStr ? dayjs(dateStr, 'YYYY-MM-DD').format('MMM DD, YYYY') : '-';
};

export const getClientNames = (data) => {
  if (!Array.isArray(data) || data.length === 0) {
    return [];
  }
  return data.reduce((acc, item) => {
    if (!acc.some((entry) => entry.name === item.clientName)) {
      acc.push({ id: item.id, name: item.clientName });
    }
    return acc;
  }, []);
};

export const filterStaffAugListData = (responseData, filterData) => {
  if (!Array.isArray(responseData) || !filterData) {
    return [];
  }

  const hasProjectFilter = filterData.project?.length > 0;
  const hasStatusFilter = filterData.status?.length > 0;

  // If no filters are applied, return the original responseData
  if (!hasProjectFilter && !hasStatusFilter) {
    return responseData;
  }

  return responseData.filter((item) => {
    const projectMatch = hasProjectFilter
      ? filterData.project.some((proj) => proj.name === item.clientName)
      : true;

    const statusMatch = hasStatusFilter
      ? filterData.status.some((stat) => stat.name === item.statusName)
      : true;

    return projectMatch && statusMatch;
  });
};

export const handleJDDownload = async (fileUrl) => {
  try {
    const response = await fetch(fileUrl);
    if (!response.ok)
      throw new Error(`Failed to fetch file: ${response.statusText}`);
    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);
    const fileName = decodeURIComponent(fileUrl.split('/').pop()
      .split('?')[0]);
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(objectUrl);
  } catch (error) {
    console.error('Error downloading the file:', error);
  }
};
